import React, { useContext } from 'react';
import PropTypes from 'prop-types';
import Header from './../../common/Header/Header';
import { LoginContext } from './../../contexts/constant/ActionTypes';
import Footer from './../../common/Footer/Footer';

const Layout = ({ children, match, history }) => {
    const loginContext = useContext(LoginContext);

    return(
        <React.Fragment>
            <Header match={match} history={history} loginContext={loginContext} />
            <div className="children">
                { children }
            </div>
            <Footer />
        </React.Fragment>
    );
}

Layout.propTypes = {
    children: PropTypes.instanceOf(Object),
    match: PropTypes.instanceOf(Object),
    history: PropTypes.instanceOf(Object)
};

Layout.defaultProps = {
    children: {},
    match: {},
    history: {}
};

export default Layout;



// WEBPACK FOOTER //
// ./containers/Layout/Layout.js